/**
 * @generated SignedSource<<b5bf7b197eefa3262379109dea80e229>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addExtraOptionPanel_AssignMutation$variables = {
  additionalAttributeID: string;
  productIDs: ReadonlyArray<string>;
};
export type addExtraOptionPanel_AssignMutation$data = {
  readonly assignProductsToAdditionalAttribute: {
    readonly additionalAttributeID: number;
    readonly id: string;
  };
};
export type addExtraOptionPanel_AssignMutation = {
  response: addExtraOptionPanel_AssignMutation$data;
  variables: addExtraOptionPanel_AssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "additionalAttributeID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIDs"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "additionalAttributeID",
        "variableName": "additionalAttributeID"
      },
      {
        "kind": "Variable",
        "name": "productIDs",
        "variableName": "productIDs"
      }
    ],
    "concreteType": "AdditionalAttribute",
    "kind": "LinkedField",
    "name": "assignProductsToAdditionalAttribute",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalAttributeID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addExtraOptionPanel_AssignMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "addExtraOptionPanel_AssignMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "dfdf703e5daf17c8c60bbac4a1c5595a",
    "id": null,
    "metadata": {},
    "name": "addExtraOptionPanel_AssignMutation",
    "operationKind": "mutation",
    "text": "mutation addExtraOptionPanel_AssignMutation(\n  $additionalAttributeID: ID!\n  $productIDs: [ID!]!\n) {\n  assignProductsToAdditionalAttribute(additionalAttributeID: $additionalAttributeID, productIDs: $productIDs) {\n    id\n    additionalAttributeID\n  }\n}\n"
  }
};
})();

(node as any).hash = "f076f6959eb3e72adc063e1d4ddf7ac0";

export default node;
